import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import LeftArrowIcon from './icons/LeftArrowIcon';

const ToolsLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isFullBleed = location.pathname === '/tools/drone-simulator';

  const getTitle = () => {
    switch (location.pathname) {
      case '/tools':
        return '교육 도구';
      case '/tools/number-draw':
        return '번호 추첨기';
      case '/tools/roulette':
        return '룰렛 추첨기';
      case '/tools/mafia-game':
        return '마피아 게임';
      case '/tools/mafia-game/create':
        return '마피아 게임 - 방 생성';
      case '/tools/mafia-game/join':
        return '마피아 게임 - 참가';
      case '/tools/drone-simulator':
        return '드론 시뮬레이터';
      default:
        if (location.pathname.startsWith('/tools/mafia-game')) {
          return '마피아 게임';
        }
        return '교육 도구';
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        /* dvh만 쓰면 일부 환경에서 높이가 0으로 계산되어 시뮬레이터가 비어 보일 수 있음 — vh를 기본으로 */
        minHeight: '100vh',
        height: isFullBleed ? '100vh' : undefined,
        maxHeight: isFullBleed ? '100vh' : undefined,
        overflow: isFullBleed ? 'hidden' : undefined,
        boxSizing: 'border-box',
      }}
    >
      <header
        style={{
          position: 'relative',
          zIndex: 2,
          backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
          color: 'white',
          padding: '0 16px',
          display: 'flex',
          alignItems: 'center',
          minHeight: 56,
          flexShrink: 0,
        }}
      >
        <button
          type="button"
          onClick={() => navigate(-1)}
          style={{
            marginRight: 16,
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            padding: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          aria-label="뒤로 가기"
        >
          <LeftArrowIcon width={24} height={24} />
        </button>
        <span style={{ flexGrow: 1, fontSize: 18, fontWeight: 600 }}>{getTitle()}</span>
        <button
          type="button"
          onClick={() => navigate('/tools')}
          style={{
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            padding: 8,
            fontSize: 14,
          }}
        >
          홈
        </button>
      </header>
      <main
        style={{
          flex: isFullBleed ? '1 1 0' : undefined,
          flexGrow: isFullBleed ? undefined : 1,
          minHeight: isFullBleed ? 0 : undefined,
          display: isFullBleed ? 'flex' : undefined,
          flexDirection: isFullBleed ? 'column' : undefined,
          overflow: isFullBleed ? 'hidden' : undefined,
          paddingTop: isFullBleed ? 0 : 32,
          paddingBottom: isFullBleed ? 0 : 32,
          maxWidth: isFullBleed ? undefined : 1200,
          margin: isFullBleed ? undefined : '0 auto',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        {/* Outlet 자식이 flex 높이를 물려받도록 (드론 등 풀블리드에서 높이 0 방지) */}
        <div
          style={{
            flex: isFullBleed ? 1 : undefined,
            flexGrow: isFullBleed ? undefined : 1,
            minHeight: isFullBleed ? 0 : undefined,
            display: isFullBleed ? 'flex' : undefined,
            flexDirection: isFullBleed ? 'column' : undefined,
            width: '100%',
            position: 'relative',
          }}
        >
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default ToolsLayout;
